import React from "react";
import "./CoursePage.css";
import SpokenBanner from "../Component/banner5.jpg";

const SpokenEnglishPage = () => {
  return (
    <div className="course-page">
      {/* ===== Banner Section ===== */}
      <div className="course-banner">
        <img src={SpokenBanner} alt="Spoken English" className="banner-img" />
      </div>

      {/* ===== Content Section ===== */}
      <div className="course-content">
        <h2>Spoken English – Language and Personality Development</h2>

        <p className="course-text">
          The <strong>Spoken English</strong> course at 
          <strong> Career Point of Information Technology (CPIT)</strong> 
          is designed to enhance your communication skills and overall personality. 
          This course helps learners build confidence in speaking, writing, and 
          understanding English — an essential skill for success in both personal 
          and professional life.
        </p>

        <p className="course-text">
          The program focuses on improving grammar, pronunciation, vocabulary, 
          and fluency through interactive sessions. Students participate in 
          group discussions, role plays, debates, and conversation practices 
          that make learning enjoyable and effective.
        </p>

        <p className="course-text">
          Apart from linguistic improvement, the course emphasizes 
          <strong>personality development</strong> and <strong>soft skills</strong>. 
          Learners are trained in public speaking, interview preparation, 
          confidence building, and professional body language — making them 
          capable and poised communicators.
        </p>

        <p className="course-text">
          At CPIT, trainers adopt a personalized approach to ensure that each 
          student progresses according to their comfort and ability level. 
          Real-life scenarios, multimedia lessons, and feedback sessions help 
          learners overcome hesitation and improve pronunciation naturally.
        </p>

        <p className="course-text">
          The course is ideal for students, professionals, job seekers, and 
          entrepreneurs who wish to strengthen their command of English to 
          communicate effectively in interviews, meetings, and presentations.
        </p>

        <p className="course-text mb-0">
          With CPIT’s <strong>Spoken English & Personality Development</strong> 
          program, learners become confident speakers ready to express themselves 
          fluently and impressively in every field of life.
        </p>
      </div>
    </div>
  );
};

export default SpokenEnglishPage;
